"use client"

import { useState, useEffect } from "react"
import { addBanner, updateBanner } from "../comman/Banner.js"

const Modal = ({ isOpen, onClose, onAddBanner, bannerToEdit, onUpdateBanner }) => {
  const [bannerType, setBannerType] = useState("")
  const [image, setImage] = useState(null)
  const [fileName, setFileName] = useState("")
  const [bannerLink, setBannerLink] = useState("")
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [publishOption, setPublishOption] = useState("both")
  const [successMessage, setSuccessMessage] = useState("")

  useEffect(() => {
    if (isOpen) {
      setBannerType(bannerToEdit ? bannerToEdit.bannerType : "")
      setImage(null)
      setBannerLink(bannerToEdit ? bannerToEdit.bannerLink : "")
      setFromDate(bannerToEdit ? bannerToEdit.fromDate : "")
      setToDate(bannerToEdit ? bannerToEdit.toDate : "")
      setPublishOption(bannerToEdit ? bannerToEdit.publishOption : "both")
      setFileName("")
    }
  }, [isOpen, bannerToEdit])

  const handleSubmit = async () => {
    if (bannerType && (image || bannerToEdit) && bannerLink && fromDate && toDate) {
      const formData = new FormData()
      formData.append("bannerType", bannerType)
      if (image) formData.append("image", image)
      formData.append("bannerLink", bannerLink)
      formData.append("fromDate", fromDate)
      formData.append("toDate", toDate)
      formData.append("publishOption", publishOption)

      try {
        if (bannerToEdit) {
          formData.append("bannerId", bannerToEdit._id)
          const updatedBanner = await updateBanner(formData)
          onUpdateBanner(updatedBanner)
        } else {
          const newBanner = await addBanner(formData)
          onAddBanner(newBanner)
        }

        setSuccessMessage("Banner submitted successfully!")
        setTimeout(() => {
          setSuccessMessage("")
          onClose()
        }, 1500)
      } catch (error) {
        console.error("Error submitting banner:", error)
        alert("Failed to submit banner")
      }
    } else {
      alert("Please fill in all required fields.")
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <h2 className="text-2xl font-semibold text-center mb-6">{bannerToEdit ? "Edit Banner" : "Add Banner"}</h2>
          {successMessage && <div className="mb-4 text-green-600 text-center font-semibold">{successMessage}</div>}
          <form className="space-y-4">
            <div>
              <label htmlFor="bannerType" className="block text-sm font-medium text-gray-700 mb-1">
                Banner Type
              </label>
              <input
                type="text"
                id="bannerType"
                value={bannerType}
                onChange={(e) => setBannerType(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter banner type"
                required
              />
            </div>
            <div>
              <label htmlFor="bannerLink" className="block text-sm font-medium text-gray-700 mb-1">
                Banner Link
              </label>
              <input
                type="text"
                id="bannerLink"
                value={bannerLink}
                onChange={(e) => setBannerLink(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter banner link"
                required
              />
            </div>
            <div>
              <label htmlFor="image" className="block text-sm font-medium text-gray-700 mb-1">
                Upload Image
              </label>
              <input
                type="file"
                id="image"
                onChange={(e) => {
                  setImage(e.target.files[0])
                  setFileName(e.target.files[0]?.name || "")
                }}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                accept="image/*"
              />
              {fileName && (
                <div className="mt-2 flex items-center justify-between bg-gray-100 p-2 rounded-md">
                  <span className="text-sm truncate">{fileName}</span>
                  <button
                    type="button"
                    onClick={() => {
                      setFileName("")
                      setImage(null)
                    }}
                    className="text-red-500 hover:text-red-700"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path
                        fillRule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700 mb-1">
                  From Date
                </label>
                <input
                  type="date"
                  id="fromDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                  required
                />
              </div>
              <div>
                <label htmlFor="toDate" className="block text-sm font-medium text-gray-700 mb-1">
                  To Date
                </label>
                <input
                  type="date"
                  id="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                  required
                />
              </div>
            </div>
            <div>
              <label htmlFor="publishOption" className="block text-sm font-medium text-gray-700 mb-1">
                Publish Option
              </label>
              <select
                id="publishOption"
                value={publishOption}
                onChange={(e) => setPublishOption(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
              >
                <option value="both">Both</option>
                <option value="student">Student</option>
                <option value="coach">Coach</option>
              </select>
            </div>
          </form>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
          <button
            type="button"
            onClick={handleSubmit}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#12143F] text-base font-medium text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:ml-3 sm:w-auto sm:text-sm"
          >
            {bannerToEdit ? "Update Banner" : "Add Banner"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default Modal

